(function () {
  document.documentElement.classList.add('ksjs');
  function init() {
    var io = 'IntersectionObserver' in window
      ? new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
          });
        }, { threshold: 0.12 })
      : null;
    document.querySelectorAll('.ks-r').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('in');
    });
    var burger = document.querySelector('.ks-burger');
    var menu = document.querySelector('.ks-mobile-menu');
    if (burger && menu) {
      var toggle = function (open) {
        menu.classList.toggle('open', open);
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.body.style.overflow = open ? 'hidden' : '';
      };
      burger.addEventListener('click', function () { toggle(!menu.classList.contains('open')); });
      menu.addEventListener('click', function (e) {
        if (e.target.closest('a') || e.target.closest('.ks-mobile-close')) toggle(false);
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
